import React from "react";
import contextProvider from "../../contextProvider";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import Panel from "../../_L1_components/Layout/Panel";
import Section from "../../_L1_components/Layout/Section";

class ProbeCard extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log(this.getAppContext().conf.API_URL);
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <Panel className="probe-card" rounded bodyClassName="p-0">
        <Row noGutters className="p-2">
          <Col xs={3}>
            <div className="probe-photo" style={{ position: "relative" }}>
              {(() => {
                let _fav_photo = this.props.probe_data.photos.length
                  ? this.props.probe_data.photos.find((_C_image) => {
                      return _C_image.fav == 1;
                    }) || this.props.probe_data.photos[0]
                  : null;
                return (
                  <div
                    className={"bg-cover rounded" + (!_fav_photo ? " bg-gray300" : "")}
                    style={{
                      paddingBottom: "100%",
                      background:
                        "url(" +
                        (_fav_photo
                          ? this.getAppContext().getApiStoreService().getCluster() +
                            this.getAppContext().conf.API_PATH +
                            "/utils/prbphotostream/" +
                            this.props.probe_data.prb_id +
                            "/" +
                            _fav_photo.filename +
                            "/1?token=" +
                            this.getAppContext().authHandler.getToken()
                          : "images/wifiprobe_icon.png") +
                        ") center center no-repeat",
                    }}
                  />
                );
              })()}
              <div
                onClick={
                  this.props.onProbePhotoClick && this.props.probe_data.photos.length
                    ? this.props.onProbePhotoClick
                    : (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.getAppContext().redirectTo(
                          "/" + this.props.probe_data.prb_id + "/setup/general"
                        );
                      }
                }
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "0",
                  bottom: "0",
                  width: "100%",
                  zIndex: "1002",
                }}
              >
                {(!this.props.probe_data.photos.length && this.props.firstLoad) ||
                this.props.probe_data.photos.length ? null : (
                  <ReactOButton
                    className="photo-edit-button m-1"
                    icon="pencil"
                    color="light"
                    size="sm"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.getAppContext().redirectTo(
                        "/" + this.props.probe_data.prb_id + "/setup/general"
                      );
                    }}
                  />
                )}
              </div>
            </div>
          </Col>
          <Col xs={9} className="pl-2">
            <div className="mb-2">
              <h5 className="text-truncate" title={this.props.probe_data.name}>
                {this.props.probe_data.name}
              </h5>
              <div className="text-muted">{this.props.probe_data.mac_address}</div>
            </div>

            {this.props.probe_data.probe_status == "maintenance" ||
            this.props.probe_data.probe_status == "not_deployed" ? (
              <div>
                <small className="text-muted mb-2">
                  <strong>PROBE STATUS: </strong>
                </small>
                <span>
                  <span>
                    {
                      this.getAppContext().conf.SETTINGS_NAME[
                        this.props.probe_data.probe_status
                      ].label
                    }
                    {this.props.probe_data.probe_status == "maintenance" ? (
                      this.props.probe_data.sync_status == 0 ? (
                        <span className="text-danger"> Offline</span>
                      ) : (
                        <span className="text-success"> Online</span>
                      )
                    ) : this.props.probe_data.sync_status == 1 ? (
                      <span className="text-success"> Online</span>
                    ) : null}
                  </span>
                </span>
              </div>
            ) : (
              <div>
                <small className="text-muted mb-2">
                  <strong>SYNC STATUS: </strong>
                </small>
                <span>
                  {this.props.probe_data.sync_status === null ||
                  this.props.probe_data.sync_status === undefined ? (
                    <span>-</span>
                  ) : this.props.probe_data.sync_status == 0 ? (
                    <span className="text-danger">Offline</span>
                  ) : (
                    <span className="text-success">Online</span>
                  )}
                </span>
              </div>
            )}

            {this.props.probe_data.sync_status === null ||
            this.props.probe_data.sync_status === undefined ? (
              <span>-</span>
            ) : this.props.probe_data.sync_status == 0 ? (
              <div>
                <small className="text-muted mb-2">
                  <strong>SINCE: </strong>
                </small>
                <span>
                  {/* {this.props.probe_data.last_update ? this.getAppContext().momentjs(this.props.probe_data.last_update, 'X').format('L LT') : '-'} */}
                  {this.props.probe_data.sync_status_ts
                    ? this.getAppContext()
                        .momentjs(this.props.probe_data.sync_status_ts, "X")
                        .format("L LT")
                    : "-"}
                </span>
              </div>
            ) : (
              <div>
                <small className="text-muted mb-2">
                  <strong>ACTIVE MEASURES: </strong>
                </small>
                <span>
                  {/* {this.props.probe_data.last_update ? this.getAppContext().momentjs(this.props.probe_data.last_update, 'X').format('L LT') : '-'} */}
                  {this.props.probe_data.active_measures_count
                    ? this.props.probe_data.active_measures_count
                    : "-"}
                </span>
              </div>
            )}
          </Col>
        </Row>

        <Section
          designType="wide"
          layoutManager="columns"
          style={
            {
              //	borderTop: '1px solid ' + this.getAppContext().colors.dark
            }
          }
        >
          {this.getAppContext().authHandler.getAccountData().type == "ADMIN" ? (
            <ReactOActionBar
              align="left"
              backgroundColor={this.getAppContext().colors.gray200}
            >
              <Link
                to={
                  "/" +
                    this.props.probe_data.prb_id +
                    "/setup/" +
                    this.getAppContext().getLocalStorageService().get("setup_position") ||
                  "general"
                }
                style={{
                  textDecoration: "none",
                }}
              >
                <ReactOButton
                  title="Device setup"
                  color="light"
                  icon="settings"
                  size="sm"
                />
              </Link>
              <Link
                to={"/" + this.props.probe_data.prb_id + "/config"}
                style={{
                  textDecoration: "none",
                }}
              >
                <ReactOButton
                  title="Measures setup"
                  color="light"
                  icon="pencil"
                  size="sm"
                />
              </Link>
              <ReactOButton
                color="light"
                icon="location"
                size="sm"
                title="Find probe on map"
                style={
                  this.props.probe_data.probe_status == "not_deployed" ||
                  this.getAppContext().authHandler.getAccountData().show_map != "yes"
                    ? { display: "none" }
                    : null
                }
                onClick={() => {
                  if (this.props.onProbePositionClick) {
                    this.props.onProbePositionClick(this.props.probe_data.prb_id);
                  }
                }}
              />
            </ReactOActionBar>
          ) : null}
          <ReactOActionBar
            align="right"
            backgroundColor={this.getAppContext().colors.gray200}
          >
            <Link
              to={"/" + this.props.probe_data.prb_id + "/active"}
              style={{
                textDecoration: "none",
                color: this.getAppContext().colors.primary,
              }}
            >
              <ReactOButton color="primary" icon="arrow-next" iconRight size="sm">
                View
              </ReactOButton>
            </Link>
          </ReactOActionBar>
        </Section>
      </Panel>
    );
  }
}

export default contextProvider(ProbeCard, {
  define: null,
});
